// GENERATED FILE - DO NOT EDIT

// This file has been automatically generated. Any modifications made to this file will be overwritten the next time it is regenerated. Please refrain from editing this file directly.

/** Austria */
const AT = /^(?:6(?:485|(?:5[0-3579]|6[013-9]|[7-9]\d)\d)\d{3,9})$/;

export default AT;
